import { render } from "./Fallback.vue?vue&type=template&id=696becb1&scoped=true"
import script from "./Fallback.vue?vue&type=script&lang=js"
export * from "./Fallback.vue?vue&type=script&lang=js"

import "./Fallback.vue?vue&type=style&index=0&id=696becb1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-696becb1"

export default script